import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import axios from ".././axios-interceptor";
import { useCallback, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { loanEventMessage,
  base_url,
  LOAN_CURRENCY_TYPE_USD,
  LOAN_CURRENCY_TYPE_BHD,
  RATING_A,
  RATING_B,
  RATING_C,
  RATING_D,
  STATUS_NEW,
  STATUS_IN_PROGRESS,
  STATUS_PROCESSED,
  STATUS_REJECTED,
  STATUS_APPROVED,
  SERVICE_REQUEST_NEW_LOAN,
  SERVICE_REQUEST_EXTEND_TENURE,
  SERVICE_REQUEST_PRE_CLOSURE,
  SERVICE_REQUEST_PARTIAL_PRE_PAYMENT,
  STATUS_CLOSED,
  LOAN_REPAYMENT_BY_BUSINESS,
  AUDITOR_ROLE,
  CURRENCY_EXCHANGE_WITH_DINAR,
  OPPORTUNITY_STATUS_OPEN,
  convertCurrency,
  formatMoney,
} from "../utilities";
import { Table } from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import { decrypt } from "../utils";
import { FundNowModal, TopUpModal, getMinimumInvestment, getEffectiveMinimum } from "./FundNowModal";
const getAboutBusinessHtml = (opportunity) => {
  return opportunity?.about_business_html || "";
};

// Mockup tokens (BenneFin-Investor-Dashboard-Preview/index.html)
// BenneFin palette (tokens in App.css :root)
const OPP_BLUE = "var(--ben-blue)";
const OPP_NAVY = "var(--ben-navy)";
const OPP_GRAYTEXT = "#7C8495";
const OPP_INK = "#292929";
const OPP_BORDER = "var(--ben-track)";
const OPP_RED = "#ED5151";

const round2 = (n) => Math.round(Number(n) * 100) / 100;
// Round DOWN so the FE never lets through an amount the backend's (unrounded) balance check rejects.
// toFixed(6) strips binary float error first, so floor2(512.05) stays 512.05 (not 512.04).
const floor2 = (n) => Math.floor(Number((Number(n) * 100).toFixed(6))) / 100;

const ratingClass = (rating) =>
  rating === RATING_A ? "rate_A" : rating === RATING_B ? "rate_B" : rating === RATING_C ? "rate_C" : "rate_D";
const ratingLetter = (rating) =>
  rating === RATING_A ? "A" : rating === RATING_B ? "B" : rating === RATING_C ? "C" : rating === RATING_D ? "D" : "-";

const curPrefix = (currency) => (currency === LOAN_CURRENCY_TYPE_USD ? "$\u00A0" : "BHD ");
const plainMoney = (amount, currency) =>
  curPrefix(currency) + Number(amount || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });

const initialsOf = (name) => {
  const words = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  return words.slice(0, 2).map((w) => w[0]).join("").toUpperCase();
};

// Funding figures for a card. A fund_now response for this opportunity (progressOverride) wins
// over the funded_amount that came with the list.
export const getCardProgress = (data, progressOverride) => {
  const target = Number(data?.admin_request_loan_amount) || 0;
  if (progressOverride) {
    return {
      target,
      funded: Number(progressOverride.funded) || 0,
      remaining: Math.max(0, Number(progressOverride.remaining) || 0),
      percent: Math.min(100, Number(progressOverride.percentFunded) || 0),
      isFullyFunded: !!progressOverride.isFullyFunded,
    };
  }
  const funded = round2(Number(data?.funded_amount) || 0);
  const remaining = Math.max(0, round2(target - funded));
  const percent = target > 0 ? Math.min(100, Math.round((funded / target) * 10000) / 100) : 0;
  return { target, funded, remaining, percent, isFullyFunded: target > 0 && remaining <= 0 };
};

const isOpportunityClosed = (data, progress) =>
  progress.isFullyFunded || (data?.status !== undefined && Number(data.status) !== OPPORTUNITY_STATUS_OPEN);

export const FundingProgress = ({ data, progress }) => {
  const done = progress.percent >= 100;
  return (
    <div>
      <div className="d-flex justify-content-between" style={{ fontSize: 10.5, color: OPP_GRAYTEXT, marginBottom: 5 }}>
        <span>
          <b style={{ color: OPP_INK, fontWeight: 700 }}>
            {Number(progress.percent).toLocaleString("en-US", { maximumFractionDigits: 2 })}%
          </b>{" "}
          funded
        </span>
        <span>{done ? "Fully funded" : plainMoney(progress.remaining, data.admin_request_loan_currency) + " remaining"}</span>
      </div>
      <div style={{ width: "100%", height: 8, background: OPP_BORDER, borderRadius: 999, overflow: "hidden" }}>
        <div
          style={{
            width: `${Math.max(0, Math.min(100, progress.percent))}%`,
            height: "100%",
            background: done ? OPP_NAVY : OPP_BLUE,
            borderRadius: 999,
            transition: "width .4s ease",
          }}
        />
      </div>
    </div>
  );
};

const ClosedBadges = () => (
  <div className="d-flex flex-wrap" style={{ gap: 6 }}>
    <span style={{ fontSize: 9.5, fontWeight: 800, padding: "4px 8px", borderRadius: 5, color: "#fff", background: OPP_NAVY }}>
      Loan Funded
    </span>
    <span style={{ fontSize: 9.5, fontWeight: 800, padding: "4px 8px", borderRadius: 5, color: "#fff", background: "var(--ben-grey-dark)" }}>
      Opportunity Closed
    </span>
  </div>
);

const statLbl = {
  fontSize: 9,
  fontWeight: 700,
  color: OPP_GRAYTEXT,
  textTransform: "uppercase",
  letterSpacing: ".03em",
  marginBottom: 3,
};
const statVal = { fontSize: 14.5, fontWeight: 800, color: OPP_INK, lineHeight: 1.25 };

function InvestorCards(props) {
  const navigate = useNavigate();
  useEffect(() => {
  if (!Cookies.get("User_Accesstoken_Investor")) {
    navigate('/');
  }
 }, []);

  let ltwo = props.loading;
  // let loading = props.setloading;
  const [loading, setLoading] = useState(true);

  const [roleCode] = useState(() => {
    try {
      return decrypt(Cookies.get('role_code'));
    } catch (error) {
      console.error('Decryption error:', error);
      return null;
    }
  });
  const canFund = roleCode !== AUDITOR_ROLE;

  const [investorData, setInvestorData] = useState([]);
  const [investorMaster, setInvestorMaster] = useState(null);
  // Available balance as the backend computes it (amount_transferred - disbursed - pledged_amount),
  // in the investor's own currency_type.
  const [balance, setBalance] = useState(null);
  const [balanceCurrency, setBalanceCurrency] = useState(LOAN_CURRENCY_TYPE_USD);
  const [exchangeRate, setExchangeRate] = useState(CURRENCY_EXCHANGE_WITH_DINAR);
  // The USD minimum/step is Math.round(100 * rate), so Fund Now must not validate with the
  // hardcoded fallback rate: it would disagree with the backend's live CurrencyExchange rate.
  const [rateLoaded, setRateLoaded] = useState(false);
  // investor_request_id -> progress from the latest fund_now response
  const [progressOverrides, setProgressOverrides] = useState({});
  // investor_request_id -> amount invested in this session (for the "Invested" note)
  const [investedNow, setInvestedNow] = useState({});
  // investor_request_id -> this investor's active Fund Now total (QA #5: the detail view shows
  // the investor's own share, not only whole-loan figures).
  const [myHoldings, setMyHoldings] = useState({});
  const loadHoldings = useCallback((investor_id) => {
    if (!investor_id) return;
    axios
      .post(base_url + "loan-investor-subscriptions/get_by_investor", { investor_id })
      .then((res) => {
        const rows = res?.data?.status === 200 && Array.isArray(res.data.data) ? res.data.data : [];
        const map = {};
        rows.filter((r) => r.state !== "withdrawn").forEach((r) => {
          const k = String(r.investor_request_id);
          map[k] = round2((map[k] || 0) + Number(r.invested_amount || 0));
        });
        setMyHoldings(map);
      })
      .catch(() => {});
  }, []);
  useEffect(() => {
    if (investorMaster?.investor_id) loadHoldings(investorMaster.investor_id);
  }, [investorMaster?.investor_id, loadHoldings]);
  const [failedLogos, setFailedLogos] = useState({});

  const [fundTarget, setFundTarget] = useState(null);
  const [showFundNow, setShowFundNow] = useState(false);
  const [showTopup, setShowTopup] = useState(false);

  // keepOnFallback: after an investment the optimistic balance is already set, so a failed /
  // "Just Boarded" dashboard response must not overwrite it with the stale mount-time master.
  const loadBalance = useCallback((master, keepOnFallback = false) => {
    if (!master?.investor_id) return;
    // "Just Boarded" / failure / timeout: fall back to the same formula on the master record, so the
    // investor is never stuck behind a balance that never arrives (the backend re-checks on fund_now).
    const applyFallback = () => {
      if (keepOnFallback) return;
      const fallback = Math.max(
        0,
        round2(
          Number(master.amount_transferred || 0) - Number(master.disbursed || 0) - Number(master.pledged_amount || 0)
        )
      );
      setBalance(fallback);
      setBalanceCurrency(master.currency_type || LOAN_CURRENCY_TYPE_USD);
    };
    axios
      .post(
        base_url + "investor-master/get_investor_dashboard",
        { investor_id: master.investor_id },
        { timeout: 15000 }
      )
      .then((res) => {
        const dash = res?.data?.data;
        if (res?.data?.status === 200 && dash && !Array.isArray(dash) && dash.available_balance !== undefined) {
          setBalance(Number(dash.available_balance) || 0);
          setBalanceCurrency(dash.currency_type || master.currency_type || LOAN_CURRENCY_TYPE_USD);
        } else {
          applyFallback();
        }
      })
      .catch((err) => {
        console.log(err);
        applyFallback();
      });
  }, []);

  const loadExchangeRate = useCallback(() => {
    axios
      .post(base_url + "currency-exchange/get_latest_currency_exchange")
      .then((res) => {
        const latest = Number(res?.data?.data?.[0]?.currency_exchange_value_with_dinar);
        if (res?.data?.status === 200 && latest > 0) {
          setExchangeRate(latest);
          setRateLoaded(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    loadExchangeRate();

    axios
      .post(base_url + "investor-master/get_investor_master_user", {
        user_id: Cookies.get("investor_user_id"),
      })
      .then((res) => {
        const master = res?.data?.data;
        if (master && master.investor_id) {
          setInvestorMaster(master);
          loadBalance(master);
        }

        axios
          .post(base_url + "investor-requests/get_investor_opportunities", {
            investor_id: master?.investor_id,
          })
          .then((res) => {
            let filtered_data = [];
            res?.data?.data?.forEach((elem) => {
              // No is_visited filter: an investor who registered interest before Fund Now must
              // still see (and be able to Fund Now) the opportunity while it is open.
              if (elem && typeof elem === "object") {
                filtered_data.push(elem);
              }
            });
            setLoading(false)
            setInvestorData(filtered_data);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      })
      .catch((err) => {
        if (err?.response?.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Investor");
          Cookies.remove("User_Refreshtoken_Investor");
          navigate("/");
        }
      });
  }, []);

  // Balance converted into a given opportunity currency.
  const balanceIn = (currency) =>
    balance === null ? 0 : Math.max(0, floor2(convertCurrency(balance, balanceCurrency, currency, exchangeRate)));

  const openFundNow = (data) => {
    if (!data || !canFund) return;
    const progress = getCardProgress(data, progressOverrides[data.investor_request_id]);
    if (isOpportunityClosed(data, progress)) return;
    if (balance === null) {
      // Retry the balance fetch so the next click can proceed instead of dead-ending.
      loadBalance(investorMaster);
      toast.error("Fetching your available balance, please try again in a moment.", { toastId: 301 });
      return;
    }
    if (!rateLoaded) {
      loadExchangeRate();
      toast.error("Fetching the latest exchange rate, please try again in a moment.", { toastId: 302 });
      return;
    }
    const currency = data.admin_request_loan_currency;
    const effectiveMin = getEffectiveMinimum(currency, exchangeRate, progress.remaining);
    setFundTarget(data);
    if (balanceIn(currency) < effectiveMin) {
      setShowTopup(true);
    } else {
      setShowFundNow(true);
    }
  };

  const handleFunded = (progress, amount) => {
    const id = fundTarget?.investor_request_id;
    loadHoldings(investorMaster?.investor_id);
    if (id && progress) {
      setProgressOverrides((prev) => ({ ...prev, [id]: progress }));
    }
    if (id) {
      setInvestedNow((prev) => ({ ...prev, [id]: round2((prev[id] || 0) + Number(amount || 0)) }));
    }
    // Optimistically deduct the investment (opportunity currency -> balance currency) so the
    // Fund Now / Top-up gates don't use a stale balance while the dashboard reloads.
    const invested = Number(amount || 0);
    const investedCurrency = fundTarget?.admin_request_loan_currency;
    if (invested > 0 && investedCurrency) {
      setBalance((prev) =>
        prev === null
          ? prev
          : Math.max(0, round2(prev - convertCurrency(invested, investedCurrency, balanceCurrency, exchangeRate)))
      );
    }
    setShowFundNow(false);
    loadBalance(investorMaster, true);
  };

  const fundProgress = fundTarget ? getCardProgress(fundTarget, progressOverrides[fundTarget.investor_request_id]) : null;
  const fundCurrency = fundTarget?.admin_request_loan_currency;

  const bannerMin = getMinimumInvestment(balanceCurrency, exchangeRate);
  const bannerLow = balance !== null && balance < bannerMin;

  const [allBusinesses, setAllBusinesses] = useState("d-block");
  const [indivBusiness, setIndivBusiness] = useState("d-none");
  const [indivLoanID, setIndivLoanID] = useState([]);
  const handleIndivBusinessDisplay = (loan_id) => {
    setAllBusinesses("d-none");
    setIndivBusiness("d-block");
    setIndivLoanID(loan_id);
  };
  const handleAllBusinessDisplay = () => {
    setIndivBusiness("d-none");
    setAllBusinesses("d-block");
  };
  return (
    <div>
      <div className={allBusinesses}>
       {ltwo || loading ?  <div className="d-flex mt-5">
       <div className="col">
         <Skeleton height={300} width={250} count={1}/>
         <Skeleton height={300} width={250} count={1}/>
         </div>
         <div className="col">
         <Skeleton height={300} width={250} count={1}/>
         <Skeleton height={300} width={250} count={1}/>

         </div>
         <div className="col">
         <Skeleton height={300} width={250} count={1}/>
         <Skeleton height={300} width={250} count={1}/>
         </div>
       </div>

                           : investorData.length !==0 ? <h1 className="m-3">Investment Opportunities</h1>
       : <div className="no_opp">
         <h1 >No Investment Opportunities</h1>
       </div>}
        {!(ltwo || loading) && (
          <div
            className="mx-3 mb-3"
            style={{
              border: `1.5px dashed ${OPP_BLUE}`,
              borderRadius: 12,
              background: "#F5F8FF",
              padding: "14px 18px",
            }}
          >
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: OPP_GRAYTEXT,
                textTransform: "uppercase",
                letterSpacing: ".04em",
              }}
            >
              Total Available Balance
            </div>
            <div style={{ fontSize: 19, fontWeight: 800, color: bannerLow ? OPP_RED : OPP_INK }}>
              {balance === null ? <Skeleton width={120} height={20} /> : formatMoney(balance, balanceCurrency)}
            </div>
          </div>
        )}
        <Row xs={1} md={3} xxl={3} xxxl={4} className={`'g-lg-2 g-md-3 g-xxl-3 p-xxl-3' `}>
          {investorData.map((data, index) => {
            const rating = data.rating;
            const progress = getCardProgress(data, progressOverrides[data.investor_request_id]);
            const closed = isOpportunityClosed(data, progress);
            const currency = data.admin_request_loan_currency;
            const tenure = Number(data.admin_request_loan_tenure);
            const displayName = (data.business_name || "").trim() || (data.business_type || "").trim() || "Business";
            const logo = (data.business_image_url || "").trim();
            const showLogo = logo !== "" && !failedLogos[data.investor_request_id];
            const invested = investedNow[data.investor_request_id];
            return (
              <Col key={data.investor_request_id || index}>
                <Card
                  className="m-lg-2 m-xxl-3 card_styl"
                  style={{
                    border: "none",
                    borderRadius: 12,
                    overflow: "hidden",
                    boxShadow: "0 2px 10px rgba(0,0,0,.05)",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ height: 4, background: `linear-gradient(90deg, ${OPP_BLUE}, ${OPP_NAVY})` }} />
                  <div className="d-flex flex-column" style={{ padding: "16px 16px 14px", gap: 12, flex: 1 }}>
                    <div className="d-flex align-items-start" style={{ gap: 12 }}>
                      <div
                        className="Cpointer"
                        onClick={() => handleIndivBusinessDisplay(data.loan_id)}
                        style={{
                          width: 52,
                          height: 52,
                          borderRadius: "50%",
                          flex: "none",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                          fontWeight: 800,
                          fontSize: 16,
                          letterSpacing: ".02em",
                          boxShadow: "0 2px 8px rgba(13,29,84,.18)",
                          overflow: "hidden",
                          background: `linear-gradient(135deg, ${OPP_BLUE}, ${OPP_NAVY})`,
                        }}
                      >
                        {showLogo ? (
                          <img
                            src={logo}
                            alt={displayName}
                            style={{ width: "100%", height: "100%", maxHeight: "none", objectFit: "cover", borderRadius: "50%" }}
                            onError={() =>
                              setFailedLogos((prev) => ({ ...prev, [data.investor_request_id]: true }))
                            }
                          />
                        ) : (
                          initialsOf(displayName)
                        )}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 14.5, fontWeight: 700, color: OPP_INK }}>{displayName}</div>
                        {(data.business_type || "").trim() !== "" && (
                          <div style={{ fontSize: 11.5, color: OPP_GRAYTEXT, marginTop: 2 }}>{data.business_type}</div>
                        )}
                      </div>
                      <img
                        className="Cpointer"
                        src="./images/icons/rightarrow.svg"
                        alt="View details"
                        style={{ width: 14, flex: "none", marginTop: 6 }}
                        onClick={() => handleIndivBusinessDisplay(data.loan_id)}
                      />
                    </div>
                    {data.notes && String(data.notes).trim() !== "" && (
                      <div style={{ fontSize: 12, color: OPP_GRAYTEXT, lineHeight: 1.4 }}>{data.notes}</div>
                    )}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 1fr)",
                        gap: 6,
                        padding: "12px 0",
                        borderTop: `1px solid ${OPP_BORDER}`,
                        borderBottom: `1px solid ${OPP_BORDER}`,
                      }}
                    >
                      <div>
                        <div style={statLbl}>Loan Amount</div>
                        <div style={statVal}>{plainMoney(data.admin_request_loan_amount, currency)}</div>
                      </div>
                      <div>
                        <div style={statLbl}>Tenure</div>
                        <div style={statVal}>
                          {Number.isFinite(tenure) && tenure > 0 ? `${tenure} ${tenure === 1 ? "month" : "months"}` : "-"}
                        </div>
                      </div>
                      <div>
                        <div style={statLbl}>Return Rate</div>
                        <div style={statVal}>{data.investor_roi !== undefined && data.investor_roi !== "" ? `${data.investor_roi}%/mo` : "-"}</div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <span style={{ fontSize: 11, fontWeight: 700, color: OPP_GRAYTEXT, textTransform: "uppercase", letterSpacing: ".03em" }}>
                        Grading
                      </span>
                      <span
                        className={ratingClass(rating)}
                        style={{ margin: 0, padding: "4px 10px", borderRadius: 6, fontSize: 12, fontWeight: 800, display: "inline-flex" }}
                      >
                        {ratingLetter(rating)}
                      </span>
                    </div>
                    <FundingProgress data={data} progress={progress} />
                    <div style={{ marginTop: "auto", paddingTop: 4 }}>
                      {invested ? (
                        <div style={{ fontSize: 11.5, fontWeight: 700, color: OPP_NAVY, marginBottom: 8 }}>
                          Invested {formatMoney(invested, currency)} &#10003;
                        </div>
                      ) : null}
                      {closed ? (
                        <ClosedBadges />
                      ) : canFund ? (
                        <button
                          type="button"
                          className="btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleIndivBusinessDisplay(data.loan_id);
                          }}
                          style={{
                            width: "100%",
                            background: OPP_BLUE,
                            color: "#fff",
                            border: "none",
                            borderRadius: 8,
                            padding: "10px 14px",
                            fontSize: 12.5,
                            fontWeight: 700,
                          }}
                        >
                          Fund Now
                        </button>
                      ) : null}
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
      <div className={indivBusiness}>
        <SingleCompanyDetails
          habd={handleAllBusinessDisplay}
          investorData={investorData}
          indivLoanID={indivLoanID}
          loading={loading}
          openFundNow={openFundNow}
          canFund={canFund}
          progressOverrides={progressOverrides}
          fundBusy={showFundNow || showTopup}
          myHoldings={myHoldings}
        />
      </div>
      <FundNowModal
        show={showFundNow}
        onHide={() => setShowFundNow(false)}
        opportunity={fundTarget}
        remaining={fundProgress ? fundProgress.remaining : 0}
        availableBalance={fundCurrency ? balanceIn(fundCurrency) : 0}
        walletBalance={balance === null ? null : Math.max(0, Number(balance) || 0)}
        rate={exchangeRate}
        investorCurrency={balanceCurrency}
        investorId={investorMaster?.investor_id}
        onFunded={handleFunded}
      />
      <TopUpModal
        show={showTopup}
        onHide={() => setShowTopup(false)}
        availableBalance={fundCurrency ? balanceIn(fundCurrency) : 0}
        minimum={fundTarget && fundProgress ? getEffectiveMinimum(fundCurrency, exchangeRate, fundProgress.remaining) : 0}
        currency={fundCurrency}
      />
    </div>
  );
}

export default InvestorCards;


const SingleCompanyDetails = (props) => {
  let investorData = props.investorData;
  let indivLoanID = props.indivLoanID;
let loading = props.loading;
  const [businessData, setBusinessData] = useState([]);
  const [loanhistory, setLoanHistory] = useState([]);



  // Display copies only: the original rows keep their numeric status, which the cards and the
  // Fund Now flow compare against OPPORTUNITY_STATUS_OPEN.
  const statusLabel = (status) =>
    status == STATUS_NEW ? "New"
      : status == STATUS_IN_PROGRESS ? "In Progress"
      : status == STATUS_PROCESSED ? "Processed"
      : status == STATUS_REJECTED ? "Rejected"
      : status == STATUS_APPROVED ? "Approved"
      : status;
  const rawOpportunity = investorData.find((item) => item.loan_id === indivLoanID);
  let indiviBussData = rawOpportunity ? [{ ...rawOpportunity, status: statusLabel(rawOpportunity.status) }] : [];
  let rating = indiviBussData[0]?.rating;
  useEffect(() => {
    if (indivLoanID != "") {
      axios
        .post(
          base_url +
            "investor-requests/get_investor_opportunity_single_business",
          {
            business_id: indiviBussData[0]?.business_id,
          }
        )
        .then((res) => {
          if (res.data.data !== "") {
            setBusinessData(res.data.data);
            setLoanHistory(res.data.data.loan_history);
            setLoanHistoryFilter(res.data.data.loan_history);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [indivLoanID]);
const drawerProgress = rawOpportunity
  ? getCardProgress(rawOpportunity, (props.progressOverrides || {})[rawOpportunity.investor_request_id])
  : null;
const drawerClosed = rawOpportunity && drawerProgress ? isOpportunityClosed(rawOpportunity, drawerProgress) : false;
  let splitdata;
  let aboutdata = businessData.about;
  if (aboutdata != undefined) {
    splitdata = aboutdata.split(". ");
  }

  let loanhistorydata = loanhistory;
  let loan_history_array = [];
  loanhistorydata?.map(each_history_record => {
    // D8: records with their own description are shown as-is (generic events, waivers, closure).
    if (each_history_record.description) {
      loan_history_array.push({ message: loanEventMessage(each_history_record), created_date_time: each_history_record.created_date_time });
      return;
    }
    //NEW LOAN REQUEST LIST
    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business requested loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if((!each_history_record.is_investor_interested) && (!each_history_record.is_admin_sent_terms_to_business)){
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin filled the profit percentage and sent to investors";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
  }
    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin rejected the new loan request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.is_investor_interested===1 && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Investor has shown interest on this loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_IN_PROGRESS && each_history_record.is_admin_sent_terms_to_business===1 && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Admin sent loan terms and awaiting for business response";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }

    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business agreed the new loan request terms";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }

    if (each_history_record.status == STATUS_PROCESSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = (
        <div className='style_loan_txt'>
          Admin paid the requested loan amount <span style={{color:"black",marginTop:"2px" }} className="ps-1 pe-1 fw-bold">{each_history_record.paid_currency +" "+ Number(each_history_record.paid_amount).toLocaleString() }</span> to business on <span style={{color:"black",marginTop:"2px"}} className="ps-1 pe-1 fw-bold">{ moment(each_history_record.paid_date).format('DD MMM YYYY')}</span>
        </div>
      );
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == LOAN_REPAYMENT_BY_BUSINESS && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = 

      <div className=''>
  Business repaid for the month of <span style={{color:"black" }} className=" fw-bold">{moment(each_history_record.tenure_date).format('MMMM')}</span>, loan tenure amount <span style={{color:"black"}} className="fw-bold">{ each_history_record.paid_currency +" "+ Number(each_history_record.paid_amount).toLocaleString()}</span> to admin on <span style={{color:"black"}} className="fw-bold">{moment(each_history_record.paid_date).format('DD MMM YYYY')}</span>
            </div>
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Business requested to extend loan tenure";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Admin approved extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_EXTEND_TENURE) {
      let message = "Admin rejected the extend tenure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }


    if (each_history_record.status == STATUS_NEW && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Business requested for pre closure of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_APPROVED && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Admin approved pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (each_history_record.status == STATUS_REJECTED && each_history_record.service_type_code == SERVICE_REQUEST_PRE_CLOSURE) {
      let message = "Admin rejected pre closure request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
    if (
      each_history_record.status == STATUS_NEW &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Business requested for partial pre-payment of a loan";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_APPROVED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin approved partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (
      each_history_record.status == STATUS_REJECTED &&
      each_history_record.service_type_code == SERVICE_REQUEST_PARTIAL_PRE_PAYMENT
    ) {
      let message = "Admin rejected partial pre-payment request";
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time,
      };
      loan_history_array.push(message_object);
    }
    if (each_history_record.status == STATUS_CLOSED && each_history_record.service_type_code == SERVICE_REQUEST_NEW_LOAN) {
      let message = "Business repaid the loan successfully"
      let created_date_time = each_history_record.created_date_time;
      let message_object = {
        message: message,
        created_date_time: created_date_time
      }
      loan_history_array.push(message_object)
    }
  }) 
const expectedReturn = indiviBussData[0]?.expected_return;
const currency = indiviBussData[0]?.admin_request_loan_currency === LOAN_CURRENCY_TYPE_USD ? "$" : "BHD";
const formattedAmount = `${currency}\u00A0${Number(expectedReturn).toLocaleString()}`;
// QA #5: the investor's own share of this loan (0 until they invest) scales the return figures.
const loanTarget = Number(indiviBussData[0]?.admin_request_loan_amount) || 0;
const myInvested = Number((props.myHoldings || {})[String(indiviBussData[0]?.investor_request_id)] || 0);
const myShare = loanTarget > 0 ? myInvested / loanTarget : 0;
const money2 = (n) => `${currency}\u00A0${(Math.round(Number(n) * 100) / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const per100 = loanTarget > 0 ? Number(expectedReturn || 0) * (100 / loanTarget) : 0;
// QA #35: while the loan is still open, the headline return is for the amount still available to
// fund (what investing now can earn); once full, the investor's own share (or the whole loan).
const availableAmt = Number(drawerProgress?.remaining || 0);
const basisShare = availableAmt > 0 && loanTarget > 0 ? availableAmt / loanTarget : myInvested > 0 ? myShare : 1;

const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

const [loanHistoryFilter, setLoanHistoryFilter]= useState([])
const [heroImageFailed, setHeroImageFailed] = useState(false)
const headers = [
  { title: "Principal", field: "admin_request_loan_amount" },
  { title: "Tenure", field: "admin_request_loan_tenure" },
  { title: "Amt Repaid", field: "principal_repaid" },
  { title: "Extend Tenure", field: "is_extend_tenure_raised" },
  { title: "Preclosure", field: "is_preclosure_raised" },
];
const handleSort = (column) => {
  let direction = "asc";
  if (sortOrder.column === column && sortOrder.direction === "asc") {
    direction = "desc";
  }
  setSortOrder({ column, direction });
  const sortedData = [...loanhistorydata].sort((a, b) => {
    const columnA = a[column];
    const columnB = b[column];
    if (typeof columnA === "string" && typeof columnB === "string") {
      return direction === "asc"
        ? columnA.localeCompare(columnB)
        : columnB.localeCompare(columnA);
    } else if (typeof columnA === "number" && typeof columnB === "number") {
      return direction === "asc" ? columnA - columnB : columnB - columnA;
    } else {
      return 0;
    }
  });
  setLoanHistoryFilter(sortedData);
};

  return (
    <div>
      <div className="indiv_bus_tilte">
        <img
          width={12}
          src="./images/left_arrow.svg"
          alt=""
          onClick={props.habd}
        />
        <h1 className="" onClick={props.habd}>
          {businessData.business_name}
        </h1>
      </div>
      <div className="row justify-content-between pe-3 ps-3 gap-5">
        <Card className="col indiv_bus_card_styl">
          <div className="">
            <h4
              className={` ${
                rating === RATING_A
                  ? "rate_A"
                  : rating === RATING_B
                  ? "rate_B"
                  : rating === RATING_C
                  ? "rate_C"
                  : "rate_D"
              }`}
            >
              {rating === RATING_A
                ? "A"
                : rating === RATING_B
                ? "B"
                : rating === RATING_C
                ? "C"
                : rating === RATING_D
                ? "D"
                : ""}
            </h4>
            {(indiviBussData[0]?.business_image_url || "").trim() !== "" && !heroImageFailed ? (
              <Card.Img
                variant="top"
                src={indiviBussData[0]?.business_image_url}
                className="indiv_busns_top_img"
                onError={() => setHeroImageFailed(true)}
              />
            ) : (
              // No business image uploaded (or it failed to load): a branded banner instead of a
              // broken-image icon.
              <div
                className="indiv_busns_top_img d-flex align-items-end"
                style={{
                  height: "10rem",
                  borderRadius: "6px 6px 0 0",
                  padding: "18px 22px",
                  background: `linear-gradient(135deg, ${OPP_BLUE}, ${OPP_NAVY})`,
                  color: "#fff",
                  fontSize: 22,
                  fontWeight: 700,
                }}
              >
                {businessData.business_name}
              </div>
            )}
            <Card.Body className="">
              <Card.Text>
                <div className="row bg-white ">
                  <div className="col">
                    <ul
                      className="nav nav-tabs d-flex"
                      id="myTab"
                      role="tablist"
                    >
                      <li className="nav-item-indiv-busns" role="presentation">
                        <button
                          className="nav-link-inv active p-1"
                          id="About-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#About-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="About-tab-pane"
                          aria-selected="true"
                        >
                          <h3>About</h3>
                        </button>
                      </li>
                      <li className="nav-item-indiv-busns" role="presentation">
                        <button
                          className="nav-link-inv p-1"
                          id="CurrentLoanDetails-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#CurrentLoanDetails-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="CurrentLoanDetails-tab-pane"
                          aria-selected="false"
                        >
                          <h3>Current Loan Details</h3>
                        </button>
                      </li>
                      <li className="nav-item-indiv-busns" role="presentation">
                        <button
                          className="nav-link-inv p-1"
                          id="loanhistory-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#loanhistory-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="loanhistory-tab-pane"
                          aria-selected="false"
                        >
                          <h3>Loan History</h3>
                        </button>
                      </li>
                      </ul>
                  </div>
                  <div className="tab-content "  id="myTabContent">
                    <div
                      className="tab-pane fade show active line_height_about_inv"
                      id="About-tab-pane"
                      role="tabpanel"
                      aria-labelledby="About-tab"
                      tabIndex="0"
                    >
                      {getAboutBusinessHtml(indiviBussData[0]) ? (
                        <div
                          className="about-business-content investor-about-content"
                          dangerouslySetInnerHTML={{ __html: getAboutBusinessHtml(indiviBussData[0]) }}
                        />
                      ) : (
                        <p className="paragraph">
                          {indiviBussData[0]?.about_business}
                        </p>
                      )}
                    </div>
                    <div
                      className="tab-pane fade loanhistory_tab loanhistory_tab_styl"
                      id="loanhistory-tab-pane"
                      role="tabpanel"
                      aria-labelledby="loanhistory-tab"
                      tabIndex="0"
                    >
                    

              <div className="invOpp_loaHistory_masterDiv">
                <div className="invOpp_loaHistory_mainDiv">
                  <Table striped  hover className="">
                          <thead >
                            <tr>
                              {headers.map((column) => (
                                <th
                                  key={column.field}
                                  onClick={() => handleSort(column.field)}
                                >
                                  {column.title}
                                  &#9662;
                                </th>
                              ))}
                            </tr>
                          </thead>
                            {loanHistoryFilter.length>0?(
                              <tbody>
                              {loanHistoryFilter?.map((data, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {loading ? (
                                      <Skeleton width={100} height={15} />
                                    ) : data.admin_request_loan_currency ===
                                      LOAN_CURRENCY_TYPE_BHD ? (
                                      "BHD " +
                                      Number(data.admin_request_loan_amount).toLocaleString()
                                    ) : (
                                      "$\u00A0"
                                      +
                                      Number(data.admin_request_loan_amount).toLocaleString())
                                    }
                                  </td>
                                  <td>
                                    {loading ? (
                                      <Skeleton width={100} height={15} />
                                    ) : (
                                      data.admin_request_loan_tenure ===1 ? data.admin_request_loan_tenure + " Month" : data.admin_request_loan_tenure >1 ? data.admin_request_loan_tenure+" Months":'-'
                                    )}
                                  </td>
                                  <td>
                                    {loading ? (
                                      <Skeleton width={100} height={15} />
                                    ) : data.admin_request_loan_currency ===
                                      LOAN_CURRENCY_TYPE_BHD ? (
                                      "BHD " +
                                      Number(data.principal_repaid).toLocaleString()
                                    ) : (
                                      "$\u00A0" +
                                      Number(data.principal_repaid).toLocaleString())
                                    }
                                  </td>
                                  <td>
                                    {loading ? (
                                      <Skeleton width={100} height={15} />
                                    ) : (
                                      data.is_extend_tenure_raised === 1 ?  "Yes" :'No'
                                    )}
                                  </td>
                                  <td>
                                    {loading ? (
                                      <Skeleton width={100} height={15} />
                                    ) : (
                                      data.is_preclosure_raised === 1 ?  "Yes" :'No'
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                            </tbody>
                          ):
                            <div className="message-box ">
                              No Loan History
                            </div>}
                        </Table>
                </div>
              </div>




                    </div>

                    <div
                      className="tab-pane fade CurrentLoanDetails_tab"
                      id="CurrentLoanDetails-tab-pane"
                      role="tabpanel"
                      aria-labelledby="CurrentLoanDetails-tab"
                      tabIndex="0"
                    >
                      {" "}
                      <div className="row mt-3">
                        <div className="col-lg-12 ">
                          <div className="row mb-3">
                            <div className="col-3">
                              <p className="text_st">Status</p>
                              <div className="bolder_text ">
                                {indiviBussData[0]?.status === undefined || indiviBussData[0]?.status === '' ? '-' : indiviBussData[0]?.status}
                              </div>
                            </div>

                            <div className="col-3">
                              <p className="text_st">Interest Frequency</p>
                              <div className="bolder_text">
                                {indiviBussData[0]?.interest_frequency === undefined || indiviBussData[0]?.interest_frequency === ''? '-' : indiviBussData[0]?.interest_frequency}
                              </div>
                            </div>
                            <div className="col">
                              <p className="text_st">Principal Frequency</p>
                              <div className="bolder_text">
                                {indiviBussData[0]?.principal_frequency}{" "}
                              </div>
                            </div>
                          </div>
                          <div className="row mt-4 mb-3">
                            <div className="col-3">
                              <p className="text_st">Amount Requested</p>
                              <span className="bolder_text">
                                {indiviBussData[0]
                                  ?.admin_request_loan_currency ==
                                LOAN_CURRENCY_TYPE_USD
                                  ? "$\u00A0" + Number(indiviBussData[0]?.admin_request_loan_amount).toLocaleString()
                                  : indiviBussData[0]
                                      ?.admin_request_loan_currency ==
                                    LOAN_CURRENCY_TYPE_BHD
                                  ? LOAN_CURRENCY_TYPE_BHD +
                                    " " +
                                    Number(indiviBussData[0]?.admin_request_loan_amount).toLocaleString()
                                  : "-"}
                              </span>
                            </div>
                            <div className="col-3">
                              <p className="text_st">Loan Tenure</p>
                              <div className="bolder_text">
                                {indiviBussData[0]?.admin_request_loan_tenure === undefined || indiviBussData[0]?.admin_request_loan_tenure=== '' ? '-' :
                                indiviBussData[0]?.admin_request_loan_tenure === 1
                                  ? indiviBussData[0]?.admin_request_loan_tenure+ " Month"
                                  : indiviBussData[0]?.admin_request_loan_tenure+ " Months" }
                              </div>
                            </div>
                            <div className="col-3">
                              <p className="text_st">Return Percentage</p>
                              <div className="bolder_text">
                                {indiviBussData[0]?.investor_roi}% per month
                              </div>
                            </div>
                          </div>

                          <div className="row mb-3 mt-4 ">
                            <div className="col">
                              <p className="text_st"> Admin Comments</p>
                              <div className="bolder_text mt-1 current_L_Details">
                                {" "}
                                {indiviBussData[0]?.admin_notes === undefined || indiviBussData[0]?.admin_notes==='' ? '-' : indiviBussData[0]?.admin_notes}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Text>
            </Card.Body>
          </div>
        </Card>

      
        <Card className="col-md-4 col InvOpp_right_tab">
        <div style={{ position: 'relative' }}>
    <Card.Img variant="top" src="./images/inv_right_top_bnr.svg" />
    <Card.Title className="inv_opp_card_title">Investment Opportunity</Card.Title>
  </div>
  <Card.Body className="InvOpp_right_tab_bdy">
              <div className="d-flex justify-content-between mb-3 row">
                <div className="blue_tab_single_inv   px-lg-2 p-xxl-2 col me-2 mb-2">
                  <p>Loan Amount</p>
                  <p className="">
                    {indiviBussData[0]?.admin_request_loan_currency ===
                    LOAN_CURRENCY_TYPE_USD
                      ? "$\u00A0"
                      : LOAN_CURRENCY_TYPE_BHD + " "}
                    {Number(indiviBussData[0]?.admin_request_loan_amount).toLocaleString()}
                  </p>
                  {myInvested > 0 && (
                    <p style={{ fontSize: 12, marginTop: 2 }}>
                      Your investment: {money2(myInvested)}
                    </p>
                  )}
                </div>

                <div className="sesame_tab_single_inv  px-lg-2 p-xxl-2 col mb-2">
                  <p>Tenure & Return Rate</p>
                  <p className="">
                    {indiviBussData[0]?.admin_request_loan_tenure === 1
                      ? indiviBussData[0]?.admin_request_loan_tenure + " Month "
                      : indiviBussData[0]?.admin_request_loan_tenure +
                        " Months"}
                    {" - "}
                    {indiviBussData[0]?.investor_roi}% per month
                  </p>
                </div>
              </div>
              <div className="indiv_bus_exp_ret">
                {availableAmt > 0 ? (
                  <>
                    {/* QA #48: lead with the amount available now; no whole-loan figure. */}
                    <p className="text-black fs-6 mb-1"> Amount currently available for investment</p>
                    <b>{money2(availableAmt)}</b>
                    <div style={{ fontSize: 12.5, color: "#3F4654", marginTop: 4 }}>
                      Expected return on this amount: <b>{money2(Number(expectedReturn || 0) * basisShare)}</b>
                    </div>
                    {myInvested > 0 && (
                      <div style={{ fontSize: 11.5, color: "#7C8495" }}>
                        Your current investment of {money2(myInvested)} earns {money2(Number(expectedReturn || 0) * myShare)}
                      </div>
                    )}
                  </>
                ) : myInvested > 0 ? (
                  <>
                    <p className="text-black fs-6 mb-1"> Your Expected Return</p>
                    <b>{money2(Number(expectedReturn || 0) * myShare)}</b>
                  </>
                ) : (
                  <>
                    <p className="text-black fs-6 mb-1"> Total Expected Return</p>
                    <b>{formattedAmount}</b>
                    {per100 > 0 && (
                      <div style={{ fontSize: 11.5, color: "#7C8495" }}>About {money2(per100)} for every {currency}&nbsp;100 you invest</div>
                    )}
                  </>
                )}
              </div>
              <hr />

<div className="row">
  <div className="col">
  <div>
                {" "}
                Interest Frequency{" "}
              </div>
              <div  className="mb-3">
                {" "}
                Principal Frequency{" "}
              </div>

  </div>
  <div className="col">
  <div className="ps-2 sesam_c"> : {indiviBussData[0]?.interest_frequency}
                </div>
                <div className="ps-2 sesam_c"> : {indiviBussData[0]?.principal_frequency === undefined || indiviBussData[0]?.principal_frequency === '' ? '-' : indiviBussData[0]?.principal_frequency}
                </div>

  </div>
</div>





              
              
              
              <span>Schedule Of Payments</span>
              <hr />
              <div className="inv_opp_table">
                <table responsive="sm" className="inv_opp_indi_right_tab">
                  <thead>
                    <tr className="justify-content-between">
                      <th className="style_table_inv_lite1">
                        <p className="pe-3">{availableAmt > 0 ? `Return on ${money2(availableAmt)}` : myInvested > 0 ? "Your Return" : "Return"}</p>
                      </th>
                      <th className="style_table_inv_lite ms-3">
                        <p className="ps-4">Scheduled Month</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="inv_opp_single_table">
                    {indiviBussData[0]?.amount.map((data) => {
                      return (
                        <tr className="">
                          <td className="style_table_inv1">
                            <div className="text-right pe-3">
                              {indiviBussData[0]?.admin_request_loan_currency}{"\u00A0"}
                              {(Math.round(Number(data.investor_profit) * basisShare * 100) / 100).toLocaleString()}
                            </div>
                          </td>
                          <td className="style_table_inv">
                            <div className="text-left ms-4">
                              {moment(data.tenure_date).format("MMM YYYY")}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>           
              </div>
        
            </Card.Body>
        <Card.Footer className="inv_opp_footer_btn">
          <small className="text-muted">
          <div className="inv_opp_ind_right_tab_btn">
                {drawerClosed ? (
                  <ClosedBadges />
                ) : props.canFund ? (
                  <button
                    className="btn blue_btn "
                    disabled={!rawOpportunity || props.fundBusy}
                    onClick={() => props.openFundNow && props.openFundNow(rawOpportunity)}
                  >
                    Confirm Investment
                  </button>
                ) : null}
              </div>
          </small>
        </Card.Footer>
      </Card>


      </div>
    </div>
  );
};
